import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import createUrl from 'tricks/string/createUrl';
import queryparse from 'tricks/string/queryparse';
import store from 'utils/store';
export function isPublicPath() {
  var pathname = document.location.pathname;
  return pathname.startsWith('/login') || pathname.startsWith('/forgot');
}
export function getLogoutPath() {
  var _document$location = document.location,
    hash = _document$location.hash,
    pathname = _document$location.pathname,
    search = _document$location.search;
  var searchObj = queryparse(search);
  if (searchObj.redirectAfterLogin) {
    delete searchObj.redirectAfterLogin;
  }
  var destination = pathname && pathname !== '/' ? createUrl('/login', _objectSpread(_objectSpread({}, searchObj), {}, {
    redirectAfterLogin: isPublicPath() ? '/' : createUrl(pathname, searchObj)
  })) : '/';
  return "".concat(destination).concat(hash);
}
export function redirectToLogin() {
  if (!isPublicPath()) {
    store.clear();
    window.location.href = getLogoutPath();
  }
}